module.exports = __webpack_public_path__ + "img/24.b5dbb8fd.png";